module.exports = __webpack_public_path__ + "img/mastercard.832a1333.svg";